module.exports = __webpack_public_path__ + "static/media/5.dd259984.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/5.svg
// module id = 156
// module chunks = 0